function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../../reducers/cms.reducer';
import { modalActions } from '../../../reducers/modal.reducer';
import ArticlesEditData from './ArticlesEditData.context';
import ArticleContactsAdd from './ArticleContactsAdd.modal';
import Table from '../../common/table/Table.react';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
var ArticleContacts = function ArticleContacts(_ref) {
  var addModalAction = _ref.addModalAction,
    contactsAction = _ref.contactsAction,
    articlesAction = _ref.articlesAction;
  var _useParams = useParams(),
    articleID = _useParams.articleID;
  var _useContext = useContext(ArticlesEditData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var contacts = state.contacts,
    articleType = state.articleType,
    archived = state.archived;
  var cmsContacts = useSelector(function (s) {
    return s.cms.contacts;
  });
  useEffect(function () {
    contactsAction({});
  }, []);
  var getContact = function getContact(contact) {
    var tmp = cmsContacts[contact.contactID];
    if (!tmp) return [];
    return {
      _id: contact.contactID,
      title: tmp.title,
      name: tmp.name,
      slot: contact.slot,
      remove: 'Remove'
    };
  };
  var tableData = {
    columns: {
      _id: {
        title: 'ID',
        visible: false
      },
      title: {
        title: 'Title'
      },
      name: 'name',
      slot: {
        title: 'Slot',
        size: 'contain'
      },
      remove: {
        title: '-',
        size: 'contain',
        onClick: function onClick(_ref2) {
          var row = _ref2.row;
          articlesAction({
            formData: {
              articleID: articleID,
              contactID: row._id
            },
            method: 'delete',
            route: 'contacts'
          });
        }
      }
    },
    data: contacts.sort(function (a, b) {
      return a.slot - b.slot;
    }).map(function (x) {
      return getContact(x);
    })
  };
  if (articleType !== 'contact') return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Contacts",
    button: {
      label: 'Add Contact',
      type: 'add',
      permission: 'edit-pos-articles',
      disabled: archived,
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(ArticleContactsAdd, {
            articleID: articleID
          })
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Table, tableData)));
};
var mdtp = {
  addModalAction: modalActions.add,
  contactsAction: cmsActions.contacts,
  articlesAction: cmsActions.articles
};
export default connect(null, mdtp)(ArticleContacts);